var adAdapter = function () {

	var active = {
		mobileBottom: function () {
			var activeClass = 'is-ad-mobile-bottom';
			var closeSelector = '#pfm-close';
			$('body').addClass(activeClass);

			var decative = function () {
				$('body').removeClass(activeClass);
				$(document).off('click', closeSelector, decative);
			};

			$(document).on('click', closeSelector, decative);
		}
	};

	return {
		active: active
	};
}();
